// Webpack imports
// Global var to use it across components
import '../scss/styles.scss';

// Class and Function Imports
import MobileMenu from './template.mobilemenu';
// import FooterMenu from './template.footerMenu';
import ScrollTop from './template.scrollTop';
import Accordion from './template.accordion';
import Teaser from './template.teaser';
import Rates from './template.rates';
import Form from './template.form';
import Sitemenu from './template.sitemenu';
import Tarif from './template.tarif';
import Tooltip from './template.tooltip';
import GoogleTracking from './template.googleTracking';
import SpeedCheck from './template.speed-check';
import AnimationTrigger from './animationTrigger';
import GoogleTrackingEvents from './../../../Digon.WebPack/src/js/googleTrackingEvents';

document.querySelector('html').classList.remove('no-js');

var inFrame = function () {
    return !(window === window.parent);
};

if (!inFrame()) {
    new MobileMenu().init();
    // new FooterMenu().init();
    new ScrollTop().init();
    new Accordion().init();
    new Teaser().init();
    new Rates().init();
    new Form().init();
    new Sitemenu().init();
    new Tarif().init();
    new Tooltip().init();
    new GoogleTracking().init();
    new SpeedCheck().init();
    AnimationTrigger.getInstance().init();
    new GoogleTrackingEvents().init();
}
